import cloneDeep from 'lodash/cloneDeep'
import ProfileInfoCategory from '@/constants/user/ProfileInfoCategory'

const mapCategories = (categories: any, filled = true) =>
  Object.entries(categories)
    .filter(([cat, state]) => state === filled)
    .map(([cat]) => ProfileInfoCategory.getCategory(cat))
    .filter(Boolean)

export default class DashboardProfileInfo {
  constructor(data: Partial<DashboardProfileInfo>) {
    Object.assign(this, cloneDeep(data))
  }

  static fromServer(data: LX.DashboardProfileInfo) {
    return new DashboardProfileInfo({
      filled: mapCategories(data.filling),
      unfilled: mapCategories(data.filling, false),
    })
  }
}
